/**
 * Vuex Stores 管理器
 * 在此处统一导出
 */


import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user';
import menu from './modules/menu';
import order from './modules/order';
import dataListstorehelper from './modules/dataListstorehelper'
import dataidscstorehelper from './modules/dataidscstorehelper'
import school from './modules/school'
import shop from './modules/shop'
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    user,
    menu,
    school,
    shop,
    dataListstorehelper,
    dataidscstorehelper,
    order
  },
  strict: false
})



// WEBPACK FOOTER //
// ./src/store/index.js